import React from "react";
import InputField from "../../../../inputField/InputField";
import {FilterableColumn, FilterRule} from "../../../styledTableHelper";
import styles from "./FilterInput.module.scss";

type FilterInputProps = {
  column: FilterableColumn;
  draftFilterRules: FilterRule[];
  updateDraftFilterRules: (rule: FilterRule) => void;
};

export default function FilterInput({
  column,
  draftFilterRules,
  updateDraftFilterRules,
}: FilterInputProps) {
  const existingRule = draftFilterRules.find(
    (rule) => rule.columnId === column.columnId
  );
  const existingValue = existingRule?.value ?? "";

  const updateFilterRule = (value: string) => {
    updateDraftFilterRules({
      columnId: column.columnId,
      value,
      operator: "in",
    });
  };

  if (column.columnType === "text") {
    return (
      <InputField
        title={column.columnHeader}
        value={existingValue}
        setValue={updateFilterRule}
        type="text"
      />
    );
  }
  return null;
}
